// extracted by mini-css-extract-plugin
export default {"popupWrapper":"popup-wrapper_popupWrapper__U3NYU","innerWrapper":"popup-wrapper_innerWrapper__daU66","closeIcon":"popup-wrapper_closeIcon__GUSl+"};